module.exports = __webpack_public_path__ + "static/img/chuguan-en.1ea65f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chuguan-en.png
// module id = kUfW
// module chunks = 1